module.exports = __webpack_public_path__ + "static/paso3soluciones-cbef850ac7bfc0b48a017da9be048303.svg";